// ProgressDots component for multi-step forms/wizards
// Shows dots for each step, highlights current step
// Props: current (0,1,2,3), total=4, className (optional)

import React from 'react';

const ProgressDots = ({ current, total = 4, className = '' }) => {
  return (
    <div className={`flex space-x-3 ${className}`}>
      {Array.from({ length: total }).map((_, index) => (
        <div
          key={index}
          className={`h-2.5 w-2.5 md:h-3 md:w-3 rounded-full transition-all duration-200 ${
            index === current 
              ? 'bg-blue-600 ring-2 ring-blue-200' 
              : index < current 
                ? 'bg-blue-400' 
                : 'bg-gray-300'
          }`}
          aria-current={index === current ? 'step' : undefined}
          aria-label={`Step ${index + 1}`}
        ></div>
      ))}
    </div>
  );
};

export default ProgressDots;
